import { useState, useEffect } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { config, priceFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const CategoryDetail = () => {
  const { id_product_category } = useParams();
  const [category, setCategory] = useState(null);
  const [subcategories, setSubcategories] = useState(null);
  const [products, setProducts] = useState(null);
  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  const navigate = useNavigate();

  useEffect(() => {
    getCategory();
  }, []);

  useEffect(() => {
    if (category) {
      getSubcategories();
      getProducts();
    }
  }, [category]);

  const getCategory = async () => {
    try {
      const requestCategory = {
        "id_product_category": id_product_category
      };
      const fetchCategory = await jwtFetch(config.ENDPOINT + 'get/product_category', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestCategory)
      });
      const responseCategory = await fetchCategory.json();
      if (responseCategory.status === 200) {
        setCategory(responseCategory.data[0]);
      } else {
        alert(responseCategory.message);
      }
    } catch (error) {
      console.error('Error in getCategory:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const getSubcategories = async () => {
    try {
      const requestSubcategories = {
        "product_category_id": id_product_category
      };
      const fetchSubcategories = await jwtFetch(config.ENDPOINT + 'get/product_subcategory', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestSubcategories)
      });
      const responseSubcategories = await fetchSubcategories.json();
      if (responseSubcategories.status === 200) {
        setSubcategories([...responseSubcategories.data].sort((a, b) => (a.product_subcategory_name || '').localeCompare(b.product_subcategory_name || '')));
      } else {
        alert(responseSubcategories.message);
      }
    } catch (error) {
      console.error('Error in getSubcategories:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const getProducts = async () => {
    try {
      const requestProducts = {
        "product_category_id": id_product_category
      };
      const fetchProducts = await jwtFetch(config.ENDPOINT + 'get/product', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestProducts)
      });
      const responseProducts = await fetchProducts.json();
      if (responseProducts.status === 200) {
        setProducts([...responseProducts.data].sort((a, b) => (a.product_name || '').localeCompare(b.product_name || '')));
      } else {
        alert(responseProducts.message);
      }
    } catch (error) {
      console.error('Error in getProducts:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  return (
    <div id="category-detail">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="product" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left" /></button> Category Detail</div>
                    {crmUser.user_level === 'Admin' && (
                      <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => window.location.href = '/product/category/edit/' + id_product_category}><i className="bi bi-pencil me-1" /> Edit</button>
                    )}
                  </div>
                  {category ? (
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Name</div>
                          <div className="col-md-8">{category.product_category_name}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Subscription Terms</div>
                          <div className="col-md-8">
                            {category.product_category_terms && (
                              <ol className="ps-3 mb-0">
                                {category.product_category_terms.split('\n').map((term, t) => (
                                  <li key={"term-" + t}>{term}</li>
                                ))}
                              </ol>
                            )}
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Status</div>
                          <div className="col-md-8"><span className={"badge bg-" + (category.product_category_status === 'Active' ? 'success' : 'danger')}>{category.product_category_status}</span></div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p>No data</p>
                  )}
                </section>

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24">Subcategory List</div>
                    {crmUser.user_level === 'Admin' && (
                      <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => window.location.href = '/product/category/subcategory/add/' + id_product_category}><i className="bi bi-plus-lg me-1" /> Add</button>
                    )}
                  </div>
                  {subcategories && subcategories.length ? (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th className="bg-primary text-light">#</th>
                            <th className="bg-primary text-light">Name</th>
                            <th className="bg-primary text-light text-center">Products</th>
                            <th className="bg-primary text-light text-center">Status</th>
                            <th className="bg-primary"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {subcategories.map((subcategory, s) =>
                            <tr key={"subcategory-" + s} onClick={() => window.location.href = '/product/category/subcategory/detail/' + subcategory.id_product_subcategory}>
                              <td valign="middle">{s + 1}</td>
                              <td valign="middle">{subcategory.product_subcategory_name}</td>
                              <td valign="middle" align="center">{subcategory.products}</td>
                              <td valign="middle" align="center"><span className={"badge bg-" + (subcategory.product_subcategory_status === 'Active' ? 'success' : 'danger')}>{subcategory.product_subcategory_status}</span></td>
                              <td valign="middle" align="right"><a className="btn btn-icon btn-outline-secondary"><i className="bi bi-eye" /></a></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p>No data</p>
                  )}
                </section>

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24">Product List</div>
                    {crmUser.user_level === 'Admin' && (
                      <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => window.location.href = '/product/add/category/' + id_product_category}><i className="bi bi-plus-lg me-1" /> Add</button>
                    )}
                  </div>
                  {products && products.length ? (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th className="bg-primary text-light">#</th>
                            <th className="bg-primary text-light">Name</th>
                            <th className="bg-primary text-light">Subcategory</th>
                            <th className="bg-primary text-light">Type</th>
                            <th className="bg-primary text-light text-end">Price</th>
                            <th className="bg-primary text-light text-center">Status</th>
                            <th className="bg-primary"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {products.map((product, p) =>
                            <tr key={"product-" + [p]} onClick={() => window.location.href = '/product/detail/' + product.id_product}>
                              <td valign="middle">{p + 1}</td>
                              <td valign="middle">{product.product_name}</td>
                              <td valign="middle">{product.subcategory_name}</td>
                              <td valign="middle">{product.product_type}</td>
                              <td valign="middle" align="right">{priceFormat(product.product_price, product.product_currency)}</td>
                              <td valign="middle" align="center"><span className={"badge bg-" + (product.product_status === 'Active' ? 'success' : 'danger')}>{product.product_status}</span></td>
                              <td valign="middle" align="right"><a className="btn btn-icon btn-outline-secondary"><i className="bi bi-eye" /></a></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p>No data</p>
                  )}
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryDetail;


